import React, { useContext, useEffect, useState } from 'react'

import "./LoginStyles.scss"
import { classNames } from 'primereact/utils'
import { ProgressSpinner } from 'primereact/progressspinner'
import { AuthContext } from '../../Context/AuthContext/AuthContext'
import { Fieldset } from 'primereact/fieldset'
import { useForm } from '../../Hooks/useForm'
import { InputText } from 'primereact/inputtext'
import { Password } from 'primereact/password'
import { Button } from 'primereact/button'
import { loginUser } from '../../API/Users/UserRequests'
import { ConfigContext } from '../../Context/ConfigContext/ConfigContext.js'
import { getLabel } from '../../Services/Language/LanguageService'
import { baseLang } from '../../Lang/BaseLang'


export const LoginScreen = () => {


    const { values, setValues, handleChange, handleInputChange, error, setError } = useForm({
        user: '',
        password: ''
    })

    const { userAuth, signIn, signOut } = useContext(AuthContext);
    const { config } = useContext(ConfigContext);

    // Variables que obtendran el valor de los input del Login
    const [showMessage, setShowMessage] = useState(false);
    const [loading, setLoading] = useState(false);

    // Funcion para obtener la IP de la maquina desde la API `https://geolocation-db.com/`
    // const getData = async () => {
    //     // TODO PETICION -> FUNCION VERIFICAR QUE LA API FUNCIONE Y OBTENGA LA IP
    //     const promesa = await fetch('https://geolocation-db.com/json/8dd79c70-0801-11ec-a29f-e381a788c2c0')
    //     await promesa.json()
    //         .then((res) => {
    //             setIP(res.IPv4)
    //         })
    //         .catch((error) => {
    //             console.error(error);
    //         })
    // }


    useEffect(() => {
        console.log(userAuth);
    }, [userAuth])

    const getFormErrorMessage = (name) => {
        return <small className="p-error">{error[name]}</small>;
    };


    const ingresoLogin = async () => {
        setLoading(true);
        const res = await loginUser(values.user, values.password);
        if (res.auth === true) {
            localStorage.setItem(process.env.REACT_APP_StorageUser, JSON.stringify({...res.user, Token: res.token}))
            localStorage.setItem(process.env.REACT_APP_StorageToken, res.token)
            window.location.href = window.location.origin + `${process.env.REACT_APP_ENV}/Home`
        } else {
            signOut()
            setValues({
                user: '',
                password: ''
            })
            setShowMessage(true);
            setError('login')
        }
        setLoading(false);
    }

    const login = async () => {
        if (values.user?.length > 0 && values.password?.length > 0) {
            ingresoLogin();
        }else{
            setError('params')
            setShowMessage(true);
        }
    }

    useEffect(() => {
        // subscriptionSW();
        window.document.title = 'PPF • Login';
        // getData();
    }, [])

    // Funcion para mostrar el logo y nombre de la empresa en la leyenda del Fieldset
    const LogoEmpresa = (
        <React.Fragment>
            <div className="fila">
                <div className="">
                    {/* <img src="https://were.ppf.com.hn/web/Logo_PPF.png" alt="Imagen" className="login__empresa-logo" /> */}
                    <img src={process.env.REACT_APP_Logo_Primario_H} alt="" className="login__empresa-logo" />
                </div>
            </div>
            <div className="fila">
                <div className="columna">
                    {/* <span style={{ marginLeft: 4 }} className="login_titulo">PPF</span> */}
                </div>
            </div>
        </React.Fragment>
    );


    return (
        <div style={{ backgroundImage: `url(${process.env.REACT_APP_FONDO_LOGIN})`, backgroundPosition: 'center' }} className="login__contenedor-imagen">
            <div className="login__contenedor-formulario" >
                <div className={classNames("progressSpinner-container spinner-login", { 'isVisible': false })}>
                    <ProgressSpinner />
                </div>

                <Fieldset legend={LogoEmpresa}>
                    <div className="p-lid login_formulario">
                        <div className="p-inputgroup">
                            <span className="p-inputgroup-addon">
                                <i className="pi pi-user"></i>
                            </span>
                            <InputText
                                id="user"
                                name="user"
                                placeholder={getLabel(baseLang, 'user', config.language)}
                                value={values.user}
                                onChange={handleInputChange}
                                autoComplete="new-password"
                            />
                        </div>
                        {getFormErrorMessage('user')}
                        <div className="p-inputgroup login_input-password ">
                            <span className="p-inputgroup-addon">
                                <i className="pi pi-lock"></i>
                            </span>
                            <Password
                                id="password"
                                name="password"
                                placeholder={getLabel(baseLang, 'password', config.language)}
                                value={values.password}
                                onChange={handleInputChange}
                                onKeyDown={e => e.key === 'Enter' && login()}
                                toggleMask={true}
                                feedback={false}
                                autoComplete="new-password"
                            // className={classNames({ 'p-invalid': isFormFieldValid('password') })}
                            />
                        </div>
                        {getFormErrorMessage('password')}
                        {showMessage && <div className="p-error">{getLabel(baseLang, 'badCredentials', config.language)}</div>}
                        <div className="p-inputgroup">
                            <div className="p-inputgroup" style={{ backgroundColor: 10 }}>
                                <Button type="button" className="p-button-Primary" width='100% '
                                    label={getLabel(baseLang, 'login', config.language)}
                                    style={{ marginTop: 10, width: "100%" }}
                                    onClick={login} loading={loading}
                                />
                            </div>
                            <br />
                        </div>
                        {getFormErrorMessage('login')}
                        {getFormErrorMessage('params')}
                    </div>
                </Fieldset>
            </div>
        </div>
    )
}
